import { GET, POST, DELETE } from '@/axios';

//TODO: Revisar la implementación de este provider, si se podría utilizar el api client

export async function getAssets(impacts = false, vulnerabilities = false, threats = false) {

    try {

        const response = await GET('assets', { params: { impacts: impacts, vulnerabilities: vulnerabilities, threats: threats } });
        return response;

    } catch (error) {

        console.error('Error al obtener activos:', error);
        throw error;

    }
}

export async function showAssets(assetId) {

    try {

        const response = await GET(`asset/${assetId}`);
        return response;

    } catch (error) {

        console.error(error);
        throw error;
    }
}

export async function createAsset(assetData) {

    try {

        const response = await POST('assets', assetData);
        return response;

    } catch (error) {

        console.error('Error al crear activo:', error);
        throw error;

    }
}

export async function updateAsset(assetData, assetId) {

    try {

        const response = await POST(`assets/${assetId}`, assetData);
        return response;

    } catch (error) {

        console.error('Error al actualizar activo:', error);
        throw error;

    }
}

export async function deleteAsset(assetId) {

    try {

        const response = await DELETE(`assets/${assetId}`);
        return response;

    } catch (error) {

        console.error('Error al eliminar activo:', error);
        throw error;

    }
}

export async function importAssetsFromExcel(file) {

    const response = await POST('assets/import-from-excel', file, {

        headers: { "Content-Type": "multipart/form-data" },

    });

    return response;

}

export async function fetchTenantAssets() {

    try {

        const response = await GET('/tenant-assets');
        return response;

    } catch (error) {

        console.error('Error al obtener activos:', error);
        throw error;

    }
}

export async function getAssetDetails(id) {

    try {

        const response = await GET('assets', {
            params: {
                id: id,
                impacts: true,
                vulnerabilities: true,
                threats: true
            }
        });

        return response;

    } catch (error) {

        console.error('Error al obtener activo por ID:', error);
        throw error;

    }
}
